var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 15.583L8.24996 15.583",
    stroke: "#253837",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 11.9165L11.9166 11.9165",
    stroke: "#253837",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7916 12.8332C18.7916 16.2901 18.7916 18.0186 17.6506 19.0926C16.5095 20.1665 14.673 20.1665 11 20.1665H10.2916C7.30219 20.1665 5.80747 20.1665 4.76944 19.4352C4.47203 19.2256 4.20799 18.9771 3.98535 18.6972C3.20829 17.7202 3.20829 16.3134 3.20829 13.4998V11.1665C3.20829 8.45026 3.20829 7.09214 3.63815 6.00744C4.32921 4.26364 5.79067 2.88815 7.64346 2.23774C8.79595 1.83317 10.239 1.83317 13.125 1.83317C14.7741 1.83317 15.5987 1.83317 16.2572 2.06436C17.316 2.43602 18.1511 3.22201 18.546 4.21847C18.7916 4.8383 18.7916 5.61437 18.7916 7.1665V12.8332Z",
    stroke: "#253837",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20833 11C3.20833 9.31246 4.57635 7.94444 6.26389 7.94444C6.87419 7.94444 7.5937 8.05138 8.18708 7.89239C8.71431 7.75112 9.12612 7.33931 9.26739 6.81208C9.42638 6.2187 9.31944 5.49919 9.31944 4.88889C9.31944 3.20135 10.6875 1.83333 12.375 1.83333",
    stroke: "#253837",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.0b6f0cfd24e5b611dfcdeeeddf556ebb.svg";
export { ForwardRef as ReactComponent };